export default {
  contact_provider: 'Contacte con su proveedor para activar esta función.',
};
